<template>
  <div class="ipad" v-if="status.length">
    <div class="ipadStatus">
      <el-row>
        <el-col :span="12">
          <!-- :class="active" -->
          <span v-for="(item,index) in status" :key="index" :class="item.moduleName == moduleName? 'active': ''" ></span>
          {{moduleName}}
        </el-col>
        <el-col :span="12">
          <dl>
            <dd>用时 {{formatShowTime}}</dd>
            <dd v-if="flowId != 15 && isTest">正答率 {{rightCircleStaff.rightRate}}%</dd>
            <!-- 暂时隐藏 -->
            <dd v-if="false">已学 {{rightCircleStaff.currentPointNum}}/{{rightCircleStaff.totalPointNum}}</dd>
          </dl>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { formatTime } from "@/utils";
import {
  getUserLocalData,
} from "@/utils/auth";
export default {
  name: "IpadStatus",
  props: {
    status: Array, // moduleStatus.sectionList
    moduleName: String,
    rightCircleStaff: {
      estimatesTime: Number, //预计时间
      rightRate: Number, //正答率
      currentPointNum: Number, //当前知识点数
      totalPointNum: Number //总知识点数
    }
  },
  data() {
    return {
      flowId: '',
      showTime: 0, // ipad 模式倒计时
      time: 0,
      source: "" // 从缓存拿数据更新
    };
  },
  computed: {
    rightCircleAction() {
      return this.rightCircleStaff.rightRate;
    }
  },
  created() {
    let { flowId } = getUserLocalData()
    this.flowId = flowId // 15 老流程
    this.changDataAction();
  },
  mounted() {
    this.time = this.qTime;
    // this.setTime(this.time);
  },
  computed: {
    ...mapGetters(["qTime", "module", "showTimeoutNotice"]),
    formatShowTime() {
      return formatTime(this.showTime);
    },
    formatTime() {
      return formatTime(this.estimatesTime);
    },
    isTest() {
      let res = false;
      if (this.module.sModuleType === 1) {
        res = false;
      } else if (this.module.sModuleType === 2) {
        res = true;
      } else {
        res = true
      }
      return res
    }
  },
  methods: {
    ...mapActions(["setQtime", "setTimeoutNotice"]),
    setTime(time) {
      if (this.timer) clearInterval(this.timer);
      this.timer = setInterval(() => {
        ++time;
        this.setQtime(time);
        this.showTime = time;
      }, 1000);
    },
    setTime3 (time) {
      this.showTime = time;
    },
    changDataAction() {
      this.$emit("changDataAction", this.source);
    },
    resetTimer() {
      this.setQtime(0);
      clearInterval(this.timer);
    },
    pauseTimer () {
      this.setQtime(this.time);
      if (this.timer) clearInterval(this.timer);
    },
  }
};
</script>
<style lang="scss">
@import '@/assets/css/theme/register.scss';
.ipadStatus {
  width: 960px;
  height: 40px;
  line-height: 40px;
  background: $theme-ipad-bgcolor;
  border-radius: 20px;
  color: $theme-status-radius-color;
  margin: 0 auto 26px;

  .el-row {
    padding: 0 40px;

    .el-col-12:nth-child(1) {
      span {
        display: inline-block;
        width: 8px;
        height: 8px;
        background: $theme-status-radius-color;
        opacity: .3;
        border-radius: 20px;
        margin-right: 8px;

        &.active {
          opacity: 1;
        }
      }
    }

    .el-col-12:nth-child(2) {
      text-align: right;
    }

    dl {
      dd {
        display: inline-block;
        margin-left: 15px;
      }
    }
  }
}

</style>




// WEBPACK FOOTER //
// src/components/IpadStatus.vue